import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { ICompany } from '../interfaces/ICompany';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError  } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment as env } from '@env/environment';
import { HttpHeaders } from '@angular/common/http';
import { HttpErrorHandler, HandleError } from './http-error-handler';
import { tap } from "rxjs/internal/operators/tap";
import { AuthGuardService } from '../auth/auth-guard.service';
import { Store } from '@ngrx/store';
import { IAccountSettings } from '../interfaces/user/IAccountSettings';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { AuthenticationService } from './AuthenticationService';
import { IUser } from '../interfaces/user/IUser';
import { UserQueryParams } from '../interfaces/IUserQueryParams';
import { PagedResult } from '../interfaces/IPagedResult';
import { ApplicationUserVM } from '../interfaces/IApplicationUserVM';
import { ITaxAdjustmentThresholdStatus } from '../interfaces/user/ITaxAdjustmentThresholdStatus';

@Injectable()
export class UserService {
  public apiAuthUrl: string;
  private apiBaseUrl: string;
  public token: string;
  private userString: string;
  private httpOptions: any;

  constructor(
      private http: HttpClient,
      private router: Router,
      private httpErrorHandler: HttpErrorHandler,
      private route: ActivatedRoute,
      public snackBar: MatSnackBar,
      public authService: AuthenticationService
  )
  {
      this.apiBaseUrl = env.hostApi;
      this.setHttpOptions();
  }

  showMessage(message: string) {
      let config = new MatSnackBarConfig();
      config.duration = 7000;
      this.snackBar.open(message, undefined, config);
  }

  getUsersUrl()
  {
      return this.apiBaseUrl + 'Users';
  }

  getUsers(params?: UserQueryParams): Observable<PagedResult<ApplicationUserVM>> {
    const url = this.apiBaseUrl + 'Users';

    let httpParams = new HttpParams();

    if (params) {
      if (params.pageNumber != null) {
        httpParams = httpParams.set('pageNumber', params.pageNumber.toString());
      }
      if (params.pageSize != null) {
        httpParams = httpParams.set('pageSize', params.pageSize.toString());
      }
      if (params.sortBy) {
        httpParams = httpParams.set('sortBy', params.sortBy);
      }
      if (params.sortDescending != null) {
        httpParams = httpParams.set('sortDescending', params.sortDescending.toString());
      }
      if (params.searchTerm) {
        httpParams = httpParams.set('searchTerm', params.searchTerm);
      }
      if (params.suspended != null) {
        httpParams = httpParams.set('suspended', params.suspended.toString());
      }
    }

    return this.http.get<PagedResult<ApplicationUserVM>>(url, {
      headers: this.httpOptions.headers,
      params: httpParams
    }).pipe(
      tap(response => console.log('Users fetched:', response)),
    );
  }




  //getUsers(): Observable<any> {

  //  var url = this.apiBaseUrl + 'Users';

  //  return this.http.get<any>(url, this.httpOptions)
  //    .pipe(
  //      tap((response: any) => console.log(response)),
  //      catchError(
  //        (err: any) => {
  //          return new Observable<any>();
  //        }
  //      ));
  //}

  getOrganizationUsers(organizationId: number): Observable<any> {

    var url = this.apiBaseUrl + 'Organizations/' + organizationId + '/Users';

      return this.http.get<any>(url, this.httpOptions)
          .pipe(
          tap((response: any) => console.log(response)),
          catchError(
              (err: any) => {
                  return new Observable<any>();
              }
          ));
  }

  updatePensionSavingsCompany(userId: string, pensionSavingsCompanyId: number): Observable<any> {
    var url = this.apiBaseUrl + 'Users/UpdatePensionSavingsCompany?userId=' + userId + '&pensionSavingsCompanyId=' + pensionSavingsCompanyId;
    
      return this.http.post<any>(url, this.httpOptions)
        .pipe(
          tap((response: any) => console.log(response)),
          catchError(
            (err: any) => {
              return new Observable<any>();
            }
          ));
  }

  updateUserBankInfo(userId: string, bankCompanyId: number, clearingNumber: string, accountNumber: string): Observable<any> {
    
    var url = this.apiBaseUrl + 'Users/UpdateUserBankInfo?userId=' + userId + '&bankCompanyId=' + bankCompanyId + '&clearingNumber=' + clearingNumber + '&accountNumber=' + accountNumber;

    return this.http.post<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => this.onFinishedUpdatingBank(response)),
        catchError((err: any) => {
          return new Observable<any>();
        })
      );
  }


  onFinishedUpdatingBank(response: any) {
    this.showMessage("Bankuppgifter sparades!");
  }

  getUserByPersonalOrOrgNumber(personalOrOrgNumber: string): Observable<any> {

  var url = this.apiBaseUrl + 'Users/GetByPersonalOrOrgNumber';
  var data = JSON.stringify(personalOrOrgNumber);

  return this.http.post<any>(url, data, this.httpOptions)
    .pipe(
      tap((response: any) => console.log(response)),
      catchError(
        (err: any) => {
          return new Observable<any>();
        }
      ));
  }

  updateCurrentUser(user: any): Observable<any> {
    return this.http.patch(`${this.apiBaseUrl}Users/Me`, user, this.httpOptions);
  }

  getUserBySearchTerm(searchTerm: string): Observable<any> {
      
    var url = this.apiBaseUrl + 'Users/GetBySearchTerm?term=' + searchTerm;
    
    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return new Observable<any>();
          }
        ));
  }

  getCompanyUserBySearchTerm(searchTerm: string): Observable<any> {
    
    var url = this.apiBaseUrl + 'Users/GetCompanyUserBySearchTerm?term=' + searchTerm;

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return new Observable<any>();
          }
        ));
  }

  getUser(userId: string): Observable<any> {

    var url = this.apiBaseUrl + 'Users/' + userId;

    return this.http.get<any>(url, this.httpOptions)
        .pipe(
        tap((response: any) => console.log(response)),
        catchError(
            (err: any) => {
                return new Observable<any>();
            }
        ));
  }

  getUserFuturePayoutTranslogs(userId: string): Observable<any> {

    var url = this.apiBaseUrl + 'Users/' + userId + '/Payouts/Future';

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return new Observable<any>();
          }
        ));
  }

  getUserCurrentYearTranslogs(userId: string): Observable<any> {

    var url = this.apiBaseUrl + 'Users/' + userId + '/Payouts/Year';

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return new Observable<any>();
          }
        ));
  }

  getUserCurrentAllTranslogs(userId: string): Observable<any> {

    var url = this.apiBaseUrl + 'Users/' + userId + '/Payouts/All';

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return new Observable<any>();
          }
        ));
  }

  getUserWageGarnishmentsForCurrentMonth(userId: string, payoutDate?: Date): Observable<any> {

    var url = this.apiBaseUrl + 'Users/' + userId + '/WageGarnishments/CurrentMonth';

    if (payoutDate) {
      const date = new Date(payoutDate);
      url += '?payoutDate=' + encodeURIComponent(date.toISOString());
    }

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return throwError(() => err);
          }
        ));
  }

  addUser(user: IUser): Observable<any> {
    
    var url = this.apiBaseUrl + 'Users';
    var data = JSON.stringify(user);

    return this.http.post<any>(url, data, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return throwError(err); // Rethrow the error
          }
        ));
  }

  addCompanyUser(user: IUser): Observable<any> {
    
    var url = this.apiBaseUrl + 'Companies/Users';
    var data = JSON.stringify(user);

    return this.http.post<any>(url, data, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return new Observable<any>();
          }
        ));
  }

  addFile(file: any): Observable<any> {

    var url = this.apiBaseUrl + 'Document';
    var data = JSON.stringify(file);

    return this.http.post<any>(url, data, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return new Observable<any>();
          }
      ));
  }

  getUserEmployerTax(userId: string, checkZeroTax: boolean = false): Observable<any> {
    
    var url = this.apiBaseUrl + 'Users/' + userId + '/EmployerTax';
    if (checkZeroTax) {
      url += '?checkZeroTax=true';
    }

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        //tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return throwError(() => err);
          }
        ));
  }

  getUserPayoutGrossSalaryInMonth(userId: string, payoutDate: Date, excludeInvoiceId?: number): Observable<any> {
    const date = new Date(payoutDate);
    const formattedDate = new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    )).toISOString();

    let url = this.apiBaseUrl + 'Users/' + userId + '/PayoutGrossSalaryInMonth?payoutDate=' + formattedDate;

    if (excludeInvoiceId != null && excludeInvoiceId > 0) {
      url += '&excludeInvoiceId=' + excludeInvoiceId;
    }

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        catchError(
          (err: any) => {
            return throwError(() => err);
          }
        ));
  }

  getUserNumberOfInvoices(userId: number): Observable<any> {

    var url = this.apiBaseUrl + 'Users/' + userId + '/NumberOfInvoices';
    
    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return new Observable<any>();
          }
        ));
  }

  getUserMunicipalityTax(payoutDate: Date, userId: string, checkZeroTax: boolean = false, ignoreTaxAdjustments: boolean = false): Observable<any> {
    
    // Format the date to ISO 8601 string
    let url = `${this.apiBaseUrl}Users/${userId}/MunicipalityTax?`;
        
    if (payoutDate != null) {
      const date = new Date(payoutDate);
      const formattedDate = new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )).toISOString();

      url += 'payoutdate=' + formattedDate;
    }


    if (checkZeroTax) {
      url += '&checkZeroTax=true';
    }
    
    if (ignoreTaxAdjustments) {
      url += '&ignoreTaxAdjustments=true';
    }

    return this.http.get<any>(url, this.httpOptions).pipe(
      catchError((err: any) => {
        return throwError(() => err);
      })
    );
  }

  getTaxAdjustmentThresholdStatus(userId: string, referenceDate?: Date, excludeInvoiceId?: number): Observable<ITaxAdjustmentThresholdStatus> {
    let url = this.apiBaseUrl + 'Users/' + userId + '/TaxAdjustments/ThresholdStatus';

    if (referenceDate != null) {
      const date = new Date(referenceDate);
      const formattedDate = new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )).toISOString();

      url += '?referenceDate=' + formattedDate;
    }

    if (excludeInvoiceId != null && excludeInvoiceId > 0) {
      url += (url.indexOf('?') >= 0 ? '&' : '?') + 'excludeInvoiceId=' + excludeInvoiceId;
    }

    return this.http.get<ITaxAdjustmentThresholdStatus>(url, { headers: this.httpOptions.headers }).pipe(
      catchError((err: any) => {
        return throwError(() => err);
      })
    );
  }


  getTotalAmountOfHealthCareDeduction(userId: string, payoutYear: number = 0): Observable<any> {
    let url = this.apiBaseUrl + 'Users/' + userId + '/HealthCareAmount';

    if (payoutYear !== 0) {
      url += '?payoutyear=' + payoutYear;
    }

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap(response => console.log(response)),
        catchError(err => {
          console.log(err);
          return throwError(err);  // Re-throw the error to the subscriber
        })
      );
  }


  //getTotalAmountOfHealthCareDeduction(payoutYear: number, userId: number): Observable<any> {

  //  var url = this.apiBaseUrl + 'Users/' + userId + '/HealthCareAmount?payoutyear=' + payoutYear;


  //  return this.http.get<any>(url, this.httpOptions)
  //    .pipe(
  //      //tap((response: any) => console.log(response)),
  //      catchError(
  //        (err: any) => {
  //          return new Observable<any>();
  //        }
  //      ));
  //}

  //checkIfUserHasReceivedSalary(userId: number): Observable<any> {

  //  var url = this.apiBaseUrl + 'Users/' + userId + '/HasReceivedSalary';
    
  //  return this.http.get<any>(url, this.httpOptions)
  //    .pipe(
  //      tap((response: any) => console.log(response)),
  //      catchError(
  //        (err: any) => {
  //          return new Observable<any>();
  //        }
  //      ));
  //}

  deleteUser(userId: string): Observable<any> {

    var url = this.apiBaseUrl + 'Users/' + userId;

    return this.http.delete<any>(url, this.httpOptions)
        .pipe(
        tap((response: any) => console.log(response)),
        catchError(
            (err: any) => {
                return new Observable<any>();
            }
        ));
  }

  getReferrals(userId: string): Observable<any> {

    var url = this.apiBaseUrl + 'Users/' + userId + '/Referrals';

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return new Observable<any>();
          }
        ));
  }

  updatetUser(user: any): Observable<any> {

    this.setHttpOptions();

    var url = this.apiBaseUrl + 'Users';
    var payload = JSON.stringify(user);

    return this.http.put<any>(url, payload, this.httpOptions)
      .pipe(
        tap((response: any) => this.onFinishedUpdatingUser(response)),
        catchError(this.handleError<any>('updateUser'))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // Log the error to the console or send it to a logging infrastructure
      console.error(`${operation} failed: ${error.message}`);

      // Re-throw the error
      return throwError(error);
    };
  }

  onUserUpdateError(error) {
      
      let errorMessage = "";

      if (error.error instanceof ErrorEvent) {
          // client-side error
      }
      else if (error.error == 'PersonalNumberExistsInDb') {
        errorMessage = 'En användare med detta personnummer existerar redan';

      }
      else if (error.error == 'EmailExistsInDb') {
        errorMessage = 'En användare med denna epostadress existerar redan';

      }
      else {
      // server-side error
      if (error.status === 409)
      {
        errorMessage = error.error;
      }
      else
      {
          errorMessage = ("Ett fel inträffade!");
        }
    }

    if (error.error != "")
        
        return throwError(errorMessage);
  }

  onFinishedUpdatingUser(response: any)
  {
      if (response != null && response.Jwt != null) {
          this.authService.saveToken(response, "");
      }

      this.showMessage("Inställningarna sparades!");
  }

  getCurrentUser(): Observable<any> {

    var url = this.apiBaseUrl + 'Users/Me';
    
    this.setHttpOptions();

      return this.http.get<any>(url, this.httpOptions)
          .pipe(
          tap((response: any) => console.log(response)),
          catchError(
              (err: any) => {
                    
                  return new Observable<any>();

              }
          ));
  }
  
  getPersonFromSparByPersonalNumber(personalNumber: string): Observable<any> {
    var url = this.apiBaseUrl + 'Spar/' + personalNumber;

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return new Observable<any>();
          }
        ));
  }
    
  userHasRole(roleName: string)
  {
    if (this.authService.userData == undefined) {
      return false;
    }
    
      var e = this.authService.userData;

    if (e == null || e.User == null || e.User.Roles == null || e.User.Roles.length == 0)
          return false;
       
      for (var i = 0; i < this.authService.userData.User.Roles.length; i++)
      {
          if (this.authService.userData.User.Roles[i].Name == roleName)
              return true;
      }

      return false;
  }

  userIsParentAccount() {
    var e = this.authService.userData;

    if (e == null || e.User == null)
      return false;
    
    return e.User.IsParentAccount;
  }

  getLoggedInUser() {
    return this.authService.userData;
  }

  isOrganizationMasterAccount() {
    
    var e = this.authService.userData;

    if (e == null || e.User == null)
      return false;

    return e.User.OrganizationMasterAccount;
  }

  userIsChildAccount() {
    var e = this.authService.userData;

    if (e == null || e.User == null)
      return false;

    return e.User.ParentAccountId == null || e.User.ParentAccountId == '' ? false : true;
  }
    
  setHttpOptions() {

    if (this.authService.userData.Jwt == null)
    return

    var bearerToken = 'bearer ' + this.authService.userData.Jwt;

    this.httpOptions = {
          headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': bearerToken
          })
      };
  }

  getCountries(): Observable<any> {
  var url = this.apiBaseUrl + 'Countries';

  return this.http.get<any>(url, this.httpOptions)
    .pipe(
      tap((response: any) => this.onCreated(response)),
      catchError(
        (err: any) => {

          return new Observable<any>();

        }
      ));
  }

  getPensionSavingsCompanies(): Observable<any> {
    var url = this.apiBaseUrl + 'PensionSavingsCompanies';

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => this.onCreated(response)),
        catchError(
          (err: any) => {

            return new Observable<any>();

          }
        ));
  }

  onCreated(response: any) {
  console.log(response);
  }

  getTaxAdjustmentTypes(): Observable<any> {

    var url = this.apiBaseUrl + 'TaxAdjustmentTypes';

    return this.http.get<any>(url, this.httpOptions)
        .pipe(
            tap((response: any) => console.log(response)),
            catchError(
                (err: any) => {
                    return new Observable<any>();
                }
            ));
  }

  getUserDocuments(userId: string): Observable<any> {

    var url = this.apiBaseUrl + 'Users/' + userId + '/Documents';

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return new Observable<any>();
          }
        ));
  }

  getCurrentUserDocuments(): Observable<any> {

    var url = this.apiBaseUrl + 'Users/Me/Documents';

    return this.http.get<any>(url, this.httpOptions)
      .pipe(
        tap((response: any) => console.log(response)),
        catchError(
          (err: any) => {
            return new Observable<any>();
          }
        ));
  }
    
}


